var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-space',[_c('img',{attrs:{"height":"64","src":require("../../assets/images/logo.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }